/* ============================================================
   CLUTCH CONFIG — parameterize per client (insurer / health-tech / wellness)
   Swap brand, accents, ad banners, scan length and the partner CTA here.
   ============================================================ */
export const CLUTCH_CONFIG = {
  brand: { name: "CarePlix" },
  accent: "#f5b301",   // amber
  accent2: "#16d6c8",  // teal
  scanDurationSec: 60, // face-scan / penalty-shoot length
  scanClient: "worldcup_careplix", // add-scan notes.client — MUST match the client the CarePlix API key is registered under
  cta: {
    label: "Get Your Full Body Check-up Done at just 1499/-",
    url: "", // partner funnel destination (leave blank to stay in-app)
  },
  // Full-body check-up lead captured on the result screen → BioIntel
  healthPackage: {
    id: "full-body-checkup-1499",
    name: "Full Body Check-up",
    price: "₹1499/-",
  },
  // Pitchside LED ad banners shown during the penalty shoot
  ads: [
    { text: "LOOP RING SERIES X" },
    { text: "AI SMART RING · ~₹30/DAY" },
    { text: "GET THE NEXT-GEN LOOP RING" },
  ],
  loop: {
    name: "Loop Ring Series X",
    pitch: "The Next-Generation AI Smart Ring — at just ~₹30/day.",
  },
};
